import { Avatar } from "@mui/material"
import { cn } from "@/lib/utils"
import React from "react"
import DefaultAvatarIcon from "./DefaultAvatarIcon"

interface IProps {
  src?: string
  name?: string
  className?: string
  size?: number
  // key?: any
  children?: React.ReactNode
  extraIcon?: React.ReactNode
  onClick?: () => void
  extraIconProps?: {
    borderColor?: string
    backgroundColor?: string
  } & React.CSSProperties
  style?: React.CSSProperties
}

const IAvatar: React.FC<IProps> = ({
  src,
  name = "",
  className,
  size,
  // key,
  children,
  extraIcon,
  onClick,
  extraIconProps,
  style,
}) => {
  const firstName = name.split("")[0]?.toUpperCase()

  function stringToColor(string: string) {
    let hash = 0
    let i

    /* eslint-disable no-bitwise */
    for (i = 0; i < string.length; i += 1) {
      hash = string.charCodeAt(i) + ((hash << 5) - hash)
    }

    let color = "#"

    for (i = 0; i < 3; i += 1) {
      const value = (hash >> (i * 8)) & 0xff
      color += `00${value.toString(16)}`.slice(-2)
    }
    /* eslint-enable no-bitwise */

    return color
  }

  function stringAvatar(name: string) {
    return {
      sx: {
        // bgcolor: stringToColor(name),
        bgColor: "rgb(31, 41, 55)",
        color: "rgb(107, 114, 128)",
        fontSize: "12px",
      },
      children: children || firstName,
    }
  }

  const handleClick = () => {
    if (onClick) {
      onClick()
    }
  }

  // 渲染默认头像或用户头像
  const renderAvatar = () => {
    // 如果没有提供src和name，显示默认头像图标
    if (!src && !name && !children) {
      return (
        <div className={cn("flex items-center justify-center", className)}>
          <DefaultAvatarIcon width={size} height={size} />
        </div>
      );
    }
    
    // 否则使用现有的头像逻辑
    return (
      <Avatar
        src={src}
        className={className}
        {...stringAvatar(name)}
        sx={{
          width: size,
          height: size,
          backgroundColor: "rgb(31, 41, 55)",
          color: "rgb(107, 114, 128)",
          fontSize: "12px",
        }}
        key={name}
      >
        {/* {renderChildren()} */}
      </Avatar>
    );
  };

  return (
    <div
      className={cn("relative")}
      style={{ width: size, height: size, ...style }}
      onClick={() => handleClick()}
    >
      {renderAvatar()}
      {extraIcon ? (
        <div
          style={{
            ...extraIconProps,
            background:
              extraIconProps?.backgroundColor ||
              "linear-gradient(180deg, #F5D588 0%, #DDA74F 100%)",
            borderColor: extraIconProps?.borderColor || "#212125",
          }}
          className="border border-[#212125] rounded-full absolute right-[-4px] bottom-0 size-[16px] flex items-center justify-center"
        >
          {extraIcon}
        </div>
      ) : null}
    </div>
  )
}

export default IAvatar
